"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitDeleteCustomClaimF = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../../actionCreators/createErrorAction");
var effects_1 = require("redux-saga/effects");
var actions_1 = require("../../../constants/actions");
var deleteCustomClaimSaga_1 = require("../../sagas/delete/deleteCustomClaimSaga");
var auth_1 = require("firebase/auth");
var description = 'submitDeleteCustomClaimF';
var submitDeleteCustomClaimF = function () {
    var currentUser, tokenResult;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!1) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.take)([actions_1.SUBMIT_DELETE_CUSTOM_CLAIM])];
            case 1:
                _a.sent();
                currentUser = (0, auth_1.getAuth)().currentUser;
                if (!currentUser) return [3 /*break*/, 4];
                return [4 /*yield*/, currentUser.getIdTokenResult()];
            case 2:
                tokenResult = _a.sent();
                return [4 /*yield*/, (0, effects_1.spawn)(deleteCustomClaimSaga_1.deleteCustomClaimSaga, {
                        apiHeaders: { token: tokenResult.token },
                    })];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                    description: description,
                }))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, (0, effects_1.put)({
                    type: actions_1.SUBMIT_DELETE_CUSTOM_CLAIM_DONE,
                })];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
exports.submitDeleteCustomClaimF = submitDeleteCustomClaimF;
